<template>
    
    <v-card>
    <v-card-title>
        <span class="headline">Análisis grupal</span>
    </v-card-title>

    <v-card-text>

        <v-select
          outline
          v-model="selected"
          :items="options"
          menu-props="auto"
          hide-details
          label="Seleccionar variable"
          v-on:change="changeSelected"
          item-text="name"
        ></v-select>

        <apexcharts ref="chart" :options="chartOptions" :series="series"></apexcharts>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="updateClose">Cerrar</v-btn>
    </v-card-actions>
    </v-card>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    export default {
    props: ["item", "dialog"],

    data: () => ({
        selected: { name: 'Acierto', key: 'success' },

        open: false,

        options: [
            { name: 'Acierto', key: 'success' },
            { name: 'Latencia (seg)', key: 'latency' },
            { name: 'Distancia (m)', key: 'pathlength' },
            { name: 'Rectitud', key: 'straightness' },

            { name: 'Tiempo de orientación (seg)', key: 'orientation_time' },
            { name: 'Distancia de orientación (m)', key: 'orientation_distance' },
            { name: 'Distancia de orientación normalizada', key: 'normalized_orientation_distance' },
            { name: 'Tiempo de orientación mezclado (seg)', key: 'mixed_orientation_time' },
            { name: 'Tiempo en el centro (seg)', key: 'center_time' },
            { name: 'Tiempo en movimiento', key: 'speed_time' },
            { name: 'Correlación de ángulo', key: 'step_correlation' },
            { name: 'Correlación giro-movimiento', key: 'meander' },
            { name: 'Tiempo en cuadrante objetivo', key: 'quadrant_time' },
            { name: 'Entropía del error', key: 'error_entropy' },
            { name: 'Entropía del camino', key: 'path_entropy' },

            { name: 'Ángulo al objetivo (prom)', key: 'angle_to_objective_mean' },
            { name: 'Ángulo al objetivo (s.d.)', key: 'angle_to_objective_std' },
            { name: 'Ángulo de movimiento (prom)', key: 'movement_direction_mean' },
            { name: 'Ángulo de movimiento (s.d.)', key: 'movement_direction_std' },
            { name: 'Distancia al objetivo (prom)', key: 'distance_to_objective_mean' },
            { name: 'Distancia al objetivo (s.d.)', key: 'distance_to_objective_std' },
            { name: 'Distancia al centro (prom)', key: 'distance_to_center_mean' },
            { name: 'Distancia al centro (s.d.)', key: 'distance_to_center_std' },
            { name: 'Ángulo al centro (prom)', key: 'angle_to_center_mean' },
            { name: 'Ángulo al centro (s.d.)', key: 'angle_to_center_std' },
            { name: 'Ángulo de giro (prom)', key: 'turning_angle_mean' },
            { name: 'Ángulo de giro (s.d.)', key: 'turning_angle_std' },
        ],

        chartOptions: {
            chart: {
                id: 'vuechart-example',
                type: 'boxPlot',
                height: 350
            },
            plotOptions: {
                boxPlot: {

                },
                line: {
                    color: "#008FFB",
                },
            },
            noData: {
                text: 'No hay datos'
            },
            tooltip: {
                shared: false,
                intersect: true
            },
            stroke: {
                curve: 'straight',
            },
            markers: {
                size: 3,
            },
            fill: {
                opacity: [0.9, 0.5, 1],
                gradient: {
                    inverseColors: true,
                    shade: 'light',
                    type: "vertical",
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                }
            },
        },
  
    }),

    created () {
        this.initialize ();
    },

    mounted() {
    },

    computed: {
        prueba() {
            return this.item
        },

        series() {
            try {
                //console.log(this.$store.state.variables);
                let items = this.$store.state.variables;
                let categories = [];
                for (const element of items) {
                    try {
                        let json = JSON.parse(element.variables);
                        var array = json.map(function (el) { 
                            return el['number'] 
                        });
                        categories = categories.concat(array);
                    }
                    catch(ee) {
                        //console.log(ee);
                    }
                }
                // lista de indices de los ensayos
                categories = categories.filter((item,index) => {return (categories.indexOf(item) == index)})
                
                // valores por ensayo para la variable elegida
                let values = [];
                for (const category of categories) {
                    let array = [];
                    for (const element of items) {
                        try {
                            let json = JSON.parse(element.variables);
                            let x = json.find(x => x.number === category)[this.selected.key];
                            if (typeof x !== "undefined") array.push(x);
                        }
                        catch(ee) {
                            //console.log(ee);
                        }
                    }
                    values.push(array);
                }
                
                var points = [];
                var line = [];
                
                let i = 1;
                for (const array of values) {
                    let boxData = this.getBoxValues(array);
                    points.push({
                        x: i,
                        y: [
                            parseFloat(boxData.low), 
                            parseFloat(boxData.q1), 
                            parseFloat(boxData.median), 
                            parseFloat(boxData.q3), 
                            parseFloat(boxData.high)
                        ]
                    });
                    line.push({
                        x: i,
                        y: parseFloat(this.average(array).toFixed(2))
                    });
                    i++;
                }

                return [
                    {
                        name: 'promedio',
                        type: 'line',
                        data: line
                    },
                    {
                        name: 'boxplot',
                        type: 'boxPlot',
                        data: points
                    }
                ]


            } catch(e) {
                console.log(e);
                return [
                    {
                        name: 'candle',
                        data: []
                    }
                ]
            }

        },

    },

    watch: {
        dialog (val) {
            if (!val) {
                this.selected = {};
            }
        },

        series () {
            this.$refs.chart.updateOptions({
            })
        }
    },

    methods: {
        initialize () {
            this.$store.dispatch('loadSerieVariables', {id: this.prueba.id})
        },

        updateClose () {
            this.$emit('close-dialog2', false);
        },

        changeSelected(name) {
            this.selected = this.options.find(x => x.name === name);
        },

        getBoxValues(data) {
            var boxValues = {};
            boxValues.low    = Math.min.apply(Math,data).toFixed(2);
            boxValues.q1     = this.quantile(data, 25).toFixed(2);
            boxValues.median = this.quantile(data, 50).toFixed(2);
            boxValues.q3     = this.quantile(data, 75).toFixed(2);
            boxValues.high   = Math.max.apply(Math,data).toFixed(2);
            return boxValues;
        },

        sortNumber(a,b) {
            return a - b;
        },

        quantile(array, percentile) {
            array.sort(this.sortNumber);
            let index = percentile/100. * (array.length-1);
            let result;
            if (Math.floor(index) == index) {
                result = array[index];
            } else {
                let i = Math.floor(index)
                let fraction = index - i;
                result = array[i] + (array[i+1] - array[i]) * fraction;
            }
            return result;
        },

        average(array) {
            var total = 0;
            for(var i = 0; i < array.length; i++) {
                total += array[i];
            }
            return total / array.length;
        }

    },

    components: {
        apexcharts: VueApexCharts,
    },

}
</script>